import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "California State Portal": {
    parameters: {
      linkUrls: ["https://cersbusiness3.calepa.ca.gov/Account/SignIn?ReturnUrl=%2f"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "CA",
  },
};
